
export default { name: "close-white" };
